/** The runtime answers its HTTP routes under the page's base path, through the service worker. */
export function primaryHttpBaseUrl(): string {
  return new URL(import.meta.env.BASE_URL, window.location.origin).toString();
}
